import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Device } from '@ionic-native/device/ngx';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { RoutingService } from 'src/app/services/routing-service/routing.service';
import { AppSettings } from 'src/app/utils/app-settings';
import { EmergencyContact } from '../../models/emergency-contact';
import { EmergencyContactService } from '../../services/emergency-contact.service';
import { RateService } from 'rate';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-edit-emergency-contact',
  templateUrl: './edit-emergency-contact.component.html',
  styleUrls: ['./edit-emergency-contact.component.scss']
})
export class EditEmergencyContactComponent extends ComponentBase {

  constructor(
    private formBuilder: FormBuilder,
    public device: Device,
    private rateService: RateService,
    private emergencyContactService: EmergencyContactService,
    private routingService: RoutingService) {
    super();
  }

  editEmgContactForm: FormGroup;
  submitted: boolean = false;
  showEmgContactFileSelector: boolean;
  showEmgContactImage: boolean = true;
  errorMessage: string;
  public config: PerfectScrollbarConfigInterface = {};

  @Input() emergency_contact: EmergencyContact;
  imageUrl = `${AppSettings.apiUrl}emergencycontact/###/photo`
  emgContact_force_reload = false;
  selected_file_name: string = "";

  ngOnInit() {
    this.emgContact_force_reload = this.emergencyContactService.force_reload_photo;
    this.initForm();
    this.loadValues();
  }

  get form() { return this.editEmgContactForm.controls; }

  loadValues() {
    if (!this.emergency_contact) {
      this.emergency_contact = new EmergencyContact();
    }
    this.editEmgContactForm.patchValue(this.emergency_contact);
  }


  initForm() {
    this.editEmgContactForm = this.formBuilder.group({
      emergency_contact_name: ['', Validators.required],
      emergency_contact_contact_number: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      emergency_contact_address_one: ['', Validators.required],
      emergency_contact_city: ['', Validators.required],
      emergency_contact_state: ['', Validators.required],
      emergency_contact_zip_code: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.editEmgContactForm.invalid) {
      return;
    }
    Object.assign(this.emergency_contact, this.editEmgContactForm.value);
    this.emergencyContactService.update(this.emergency_contact).subscribe(res => {
      this.rateService.showRate();
      this.onCancel();
    }, err => {
      console.error(err)
    });
  }

  onCancel() {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'my-account', 'student'];
    route.append_current_url_to_history = true;
    route.query_params = { 'suboption': '15' };
    this.routingService.navigate(route);
  }

  onDelete() {
    if (confirm("Are you sure you want to delete?")) {
      this.emergencyContactService.delete(this.emergency_contact.emergency_contact_id).subscribe(res => {
        this.onCancel();
      }, err => {
        console.error(err)
      });;
    }
  }

  onChangeEmgContactPhoto() {
    this.showEmgContactFileSelector = true;
  }

  onEmgContactFileSelect(id: number, files: Array<File>) {
    this.showEmgContactImage = false;
    this.showEmgContactFileSelector = false;
    let selectedFile = files[0];
    this.emergencyContactService.updatePhoto(id, selectedFile)
      .subscribe(res => {
        if (res.message) {
          this.errorMessage = res.message;
          setTimeout(() => {
            this.errorMessage = null;
          }, 3000);
        }
        if (res.file_guid) {
          this.emergency_contact.photo_guid = res.file_guid;
        }
        this.selected_file_name = selectedFile.name;
        this.emgContact_force_reload = true;
        this.showEmgContactImage = true;
      });
  }
}
